import { useState } from 'react';
import { observer } from 'mobx-react';

// Components
import { Container, TopLevelButton, GroupButton, ButtonGrid } from './styles';

interface LocationButtonGroupProps {
  onSearch: (search: string) => void;
  locations: Location[];
  className: string;
}

function LocationButtonGroup({ className, onSearch, locations }: LocationButtonGroupProps) {
  const [expanded, setIsExpanded] = useState(false);

  const { landing_page_group_name, locationShortId } = locations[0];

  return (
    <Container className={className}>
      <TopLevelButton
        type="primary"
        onClick={() => setIsExpanded(!expanded)}
        data-testid={`location-button-group-${landing_page_group_name}`}
      >
        {landing_page_group_name ? landing_page_group_name?.toUpperCase() : locationShortId?.toUpperCase()}
      </TopLevelButton>
      {expanded && locations.length > 0 && (
        <ButtonGrid>
          {locations.map((loc) => (
            <GroupButton
              key={loc.locationShortId}
              type="primary"
              onClick={() => onSearch(loc.locationShortId || loc.externalUrl)}
              disabled={loc.order_allowed === 'off'}
              data-testid={`location-button-${locationShortId}`}
            >
              {loc.landing_page_name ? loc.landing_page_name?.toUpperCase() : loc.locationShortId?.toUpperCase()}
              {loc.order_allowed === 'off' ? ' (Currently Unavailable)' : ''}
            </GroupButton>
          ))}
        </ButtonGrid>
      )}
    </Container>
  );
}

export default observer(LocationButtonGroup);
